import styled from "@emotion/styled";
import { Theme } from "@silvertours/front-shared";
var PrimaryTitle = /*#__PURE__*/ styled("h1", {
    target: "e9nspsd0"
})("margin:0;font-family:", function(param) {
    var theme = param.theme;
    return theme.fontFamily.alternate;
}, ";font-weight:bold;font-size:1.375rem;line-height:1.25;text-align:center;color:", function(param) {
    var theme = param.theme;
    return theme.color.secondary100;
}, ";", Theme.mq("sm"), "{text-align:left;}", Theme.mq("lg"), "{font-size:1.75rem;line-height:1.4285;}");
var SupplierList = /*#__PURE__*/ styled("ul", {
    target: "e9nspsd1"
})("grid-column:", function(param) {
    var isStandAlone = param.isStandAlone;
    return isStandAlone ? "span 2" : "";
}, ";display:flex;flex-wrap:wrap;align-items:center;justify-content:space-around;gap:1rem;margin:0 auto;padding:0;", Theme.mq("sm"), "{margin-left:0;margin-right:0;justify-content:space-between;}", Theme.mq("lg"), "{padding-top:", function(param) {
    var isStandAlone = param.isStandAlone;
    return isStandAlone ? "0" : "0.5rem";
}, ";padding-bottom:", function(param) {
    var isStandAlone = param.isStandAlone;
    return isStandAlone ? "0" : "0.5rem";
}, ";align-items:end;justify-content:", function(param) {
    var isStandAlone = param.isStandAlone;
    return isStandAlone ? "center" : "end";
}, ";gap:", function(param) {
    var isStandAlone = param.isStandAlone;
    return isStandAlone ? "2.5rem" : "1.5rem";
}, ";}");
var SupplierListItem = /*#__PURE__*/ styled("li", {
    target: "e9nspsd2"
})("display:inline-flex;align-items:center;svg{width:auto;height:1.5rem;vertical-align:bottom;filter:grayscale() opacity(0.7);}");
var SupplierWrapper = /*#__PURE__*/ styled("div", {
    target: "e9nspsd3"
})("display:grid;gap:1rem;padding:3rem 0 2rem;", function(param) {
    var includeSearch = param.includeSearch;
    return includeSearch && "".concat(Theme.mq("lg"), " {\n    grid-template-columns: repeat(2, 0.5fr);\n  }\n\n  ").concat(Theme.mq("xl"), " {\n    grid-template-columns: 0.4fr 0.6fr;\n  }");
});
export { PrimaryTitle, SupplierList, SupplierListItem, SupplierWrapper };
